const LAT_DEG_TO_METERS = 111_111

const latDistInMeters = (lat1: number, lat2: number) =>
	Math.abs(lat1 - lat2) * LAT_DEG_TO_METERS

const LON_DEG_TO_KM = (lat: number) => (40075 * Math.cos(lat)) / 360

const lonDistInMeters = (DEG_TO_KM: number, lon1: number, lon2: number) =>
	Math.abs(lon1 - lon2) * DEG_TO_KM * 1000

export function group<T extends { readonly latlon: readonly [lat: number, lon: number] }>(
	arr: readonly T[],
	radiusMeters: number
): T[][]
{
	const groups: { c: T; items: T[] }[] = []
	// 1. sort by lat
	arr = arr.slice().sort((a, b) => a.latlon[0] - b.latlon[0])
	// 2. split those that are more than 100m apart
	let lastGroup = { c: arr[0], items: [arr[0]] }
	arr = arr.slice(1)
	for (const x of arr)
	{
		if (latDistInMeters(lastGroup.c.latlon[0], x.latlon[0]) > radiusMeters)
		{
			groups.push(lastGroup)
			lastGroup = { c: x, items: [x] }
		}
		else
		{
			lastGroup.items.push(x)
		}
	}
	groups.push(lastGroup)

	// 3. sort by lon
	for (const group of groups)
		group.items = group.items.sort((a, b) => a.latlon[1] - b.latlon[1])

	// 4. split those that are more than 100m apart
	const newGroups: T[][] = []
	for (const group of groups)
	{
		let lastGroup = { c: group.items[0], items: [group.items[0]] }

		group.items = group.items.slice(1)

		// we should only calculate longitude coefs for the first item in the group
		// because we already sorted by longitude
		let lonCoef = LON_DEG_TO_KM(lastGroup.c.latlon[0])

		for (const x of group.items)
		{
			if (lonDistInMeters(lonCoef, lastGroup.c.latlon[1], x.latlon[1]) > radiusMeters)
			{
				newGroups.push(lastGroup.items)
				lastGroup = { c: x, items: [x] }
				lonCoef = LON_DEG_TO_KM(lastGroup.c.latlon[0])
			}
			else 
			{
				lastGroup.items.push(x)
			}
		}
		newGroups.push(lastGroup.items)
	}
	return newGroups
}
